
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["heart",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#484f5b","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/heart"}},[_c('path',{attrs:{"d":"M12.62 20.81a2.181 2.181 0 01-1.24 0C8.48 19.82 2 15.69 2 8.69A5.574 5.574 0 017.56 3.1 5.515 5.515 0 0112 5.34a5.547 5.547 0 0110 3.35c0 7-6.48 11.13-9.38 12.12z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M5.834 10.107a4.012 4.012 0 014.141-2.391","opacity":".34"}})])])
          )
        }
      }
    